import React from "react";
import BookmarkRounded from "@material-ui/icons/BookmarkRounded";
import MemoryRounded from "@material-ui/icons/MemoryRounded";
import PhoneRounded from "@material-ui/icons/PhoneRounded";
import ChatBubbleRounded from "@material-ui/icons/ChatBubbleRounded";
import WarningRounded from "@material-ui/icons/WarningRounded";
import BlockRounded from "@material-ui/icons/BlockRounded";
import CheckCircleRounded from "@material-ui/icons/CheckCircleRounded";
import MonetizationOnRounded from "@material-ui/icons/MonetizationOnRounded";
import AssignmentRounded from "@material-ui/icons/AssignmentRounded";
import LockRounded from "@material-ui/icons/LockRounded";
import StarRounded from "@material-ui/icons/StarRounded";
import TrackChangesRounded from "@material-ui/icons/TrackChangesRounded";
import PhotoCameraRounded from "@material-ui/icons/PhotoCameraRounded";
import ScheduleRounded from "@material-ui/icons/ScheduleRounded";
import AccountBalanceRounded from "@material-ui/icons/AccountBalanceRounded";
import AnnouncementRounded from "@material-ui/icons/AnnouncementRounded";

// Ícones das seções (o banco guarda só a chave, ex.: "telefone")
export const ICONES_SECAO = {
  pin: BookmarkRounded,
  robo: MemoryRounded,
  telefone: PhoneRounded,
  chat: ChatBubbleRounded,
  atencao: WarningRounded,
  proibido: BlockRounded,
  certo: CheckCircleRounded,
  dinheiro: MonetizationOnRounded,
  lista: AssignmentRounded,
  cadeado: LockRounded,
  estrela: StarRounded,
  alvo: TrackChangesRounded,
  camera: PhotoCameraRounded,
  relogio: ScheduleRounded,
  banco: AccountBalanceRounded,
  aviso: AnnouncementRounded,
};

// Seções antigas (criadas com emoji) continuam aparecendo com o emoji.
export const IconeSecao = ({ icone, ...props }) => {
  const Icone = ICONES_SECAO[icone || "pin"];
  if (Icone) return <Icone {...props} />;
  return <span style={{ fontSize: "1.1em", lineHeight: 1 }}>{icone}</span>;
};
